<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Búsqueda de personas</strong>
          </div>
          <div>
            <b-row class="my-1">
              <b-col sm = "1">
                <label>Nombre</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="buscar_por_nombre()" > 
                  <b-input-group @submit.prevent="buscar_por_nombre()">
                    <b-form-input size="sm" type="text" v-model="datosFormulario.nombre"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button  size="sm" type="submit"  class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "1">
                <label>Rut</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="buscar_por_rut()" > 
                  <b-input-group @submit.prevent="buscar_por_rut()">
                    <b-form-input size="sm" type="text" v-model="datosFormulario.rut"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button size="sm" type="submit" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>  
            </b-row>
            
            <b-row class="my-1">
              <b-col sm = "1">
                <label>Póliza</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="buscar_por_poliza()" > 
                  <b-input-group @submit.prevent="buscar_por_poliza()">
                    <b-form-input size="sm" type="text" v-model="datosFormulario.poliza"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button size="sm" type="submit" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "1">
                <label>Código</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="buscar_por_codigo()" > 
                  <b-input-group @submit.prevent="buscar_por_codigo()">
                    <b-form-input size="sm" type="text" v-model="datosFormulario.codigo"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button size="sm" type="submit" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
            </b-row>

          </div>
          <div>
            <div slot="footer">
              <div class="form-actions text-right">
                <el-row>
                  <el-col>
                    <b-button variant="primary" @click="Limpiar" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                  </el-col> 
                </el-row>                
              </div>
            </div>
            
          </div>
          
        </b-card>

        <!-- Consulta de Clientes -->
        <b-card v-if="consulta === true">
          <div slot="header">
            <strong>Consulta de Clientes</strong>
          </div>
          <div>
            <b-row class="my-1">
              <b-col sm="2">
                <label for="input-small">Código</label>
              </b-col>
              <b-col sm="2">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  placeholder="Código"
                  disabled
                  v-model="datosFormulario.cccodigo">
                </b-form-input>
              </b-col>
              <b-col sm="2">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  placeholder="Rut"
                  disabled
                  v-model="datosFormulario.ccrut">
                </b-form-input>
              </b-col>
              <b-col sm="4">
                <b-form-input 
                  id="input-small" 
                  size="sm" 
                  type="text" 
                  placeholder="Nombre"
                  disabled
                  v-model="datosFormulario.ccnombre">
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label for="input-small">Fecha Inicial:</label>
              </b-col>
              <b-col sm="2">
                <b-form-datepicker 
                  id="datepicker-feinicial"
                  size="sm" 
                  locale="es-cl" 
                  :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                  v-model="datosFormulario.feinicio">
                </b-form-datepicker>
              </b-col>
              <b-col sm="2">
                <label for="input-small">Fecha Final:</label>
              </b-col>
              <b-col sm="2">
                <b-form-datepicker 
                  id="datepicker-fefin" 
                  size="sm" 
                  locale="es-cl" 
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  v-model="datosFormulario.fefin">
                </b-form-datepicker>
              </b-col>
            </b-row>  

            <b-row  class="my-1">
              <b-col sm="2">
                <label for="input-small">Participa como:</label>
              </b-col>
              <b-col sm="2">
                 <b-form-select 
                  size="sm"
                  :options="valParticipacion" 
                  v-model="datosFormulario.participacion">
                </b-form-select>
              </b-col>
            </b-row>  

          </div>

          <div>
            <div slot="footer">
              <div class="form-actions text-right">
                <el-row>
                  <el-col>
                    <b-button variant="primary" @click="consultarTab" ><i class="fa fa-search"></i> Consultar</b-button>
                    <b-button variant="primary" @click="pre_insertar_limpiar" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                    <!-- <b-button variant="primary"  style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button> -->
                    <b-button variant="primary" @click="tieneAcceso=true; consulta=false" style="margin-left: 10px;"><i class="fa fa-sign-out"></i> Volver</b-button>
                  </el-col> 
                </el-row>                
              </div>
            </div>
            
          </div>
        </b-card>

        <!-- Detalle de la consulta -->
        <b-card v-if="consulta === true">
          <div slot="header">
            <!-- <strong>Consulta de Clientes</strong> -->
          </div>
          <div>
            
            <br>
            <b-tabs content-class="mt-3" justified lazy v-model="tabIndex">
              <b-tab title="Persona" active >
                <Persona ref="tabPersona" 
                         :cod_afianzado="datosFormulario.cccodigo"></Persona>
              </b-tab>
              <b-tab  title="Pólizas">
                <Polizas ref="tabPolizas"  
                        :cod_afianzado="datosFormulario.cccodigo" 
                        :participacion="datosFormulario.participacion"
                        :fedesde="this.convierteFecha(datosFormulario.feinicio)"
                        :fehasta="this.convierteFecha(datosFormulario.fefin)"
                        >
                </Polizas>
              </b-tab>
              <b-tab title="Deudas">
                <Deudas ref="tabDeudas"
                        :cod_afianzado="datosFormulario.cccodigo" 
                        :participacion="datosFormulario.participacion"
                        >

                </Deudas>
              </b-tab>
              <b-tab title="Siniestros" >
                <Siniestros ref="tabSiniestros"
                            :cod_afianzado="datosFormulario.cccodigo" 
                            :participacion="datosFormulario.participacion"
                            >

                </Siniestros>
              </b-tab>
              <b-tab title="Cúmulo" >
                <Cumulo ref="tabCumulo"
                        :cod_afianzado="datosFormulario.cccodigo" 
                        :participacion="datosFormulario.participacion"
                        >

                </Cumulo>
              </b-tab>
              <b-tab title="Monedas" >
                <Monedas ref="tabMonedas"
                        >

                </Monedas>
              </b-tab>
              <b-tab title="Contragarantías" >
                 <Contragarantias ref="tabcontragaratias"
                                  :cod_afianzado="datosFormulario.cccodigo" 
                                  :fedesde="this.convierteFecha(datosFormulario.feinicio)"
                                  :fehasta="this.convierteFecha(datosFormulario.fefin)"
                      >
                      
                 </Contragarantias>

              </b-tab>

            </b-tabs>
          </div>
        </b-card>

      </b-col>
    </b-row>
    
    <b-modal
      size="lg"
      scrollable
      hide-footer
      title="Búsqueda por nombre"
      cancel-title="Cancelar"
      v-model="modalNombre"
      @cancel="modalNombre = false"
    >
    <b-row class="my-1">
      <b-col sm="6">
        <label>Buscar:</label>
        <b-form-group label label-for="filtroProceso">
          <b-form-input
            id="filtroNombre"
            type="text"
            placeholder="Filtrar"
            v-model="filtersNombre[0].value"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br>

    <b-row>
      <b-col lg="12">             
        <div ref="refTable2">
          <data-tables ref="refTable2"
            :data="data1"
            name="table1"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filtersNombre"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titles2"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
                <template slot-scope="scope">
                    <div v-if="title.prop == 'codigo'">  
                        <b-link type="text" v-if="scope.row.codigo > 0" @click="selecciona_afianzado(scope.row.codigo, scope.row.rut, scope.row.nombre)" >{{scope.row.codigo}}</b-link>
                        <p v-else >{{scope.row.codigo}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>
              
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>

    <b-modal
      size="lg"
      scrollable
      hide-footer
      :title="modaltitle"
      cancel-title="Cancelar"
      v-model="modalId"
      @cancel="modalId = false"
    >
    <b-row class="my-1">
      <b-col sm="6">
        <label>Buscar:</label>
        <b-form-group label label-for="filtroProceso">
          <b-form-input
            id="filtroId"
            type="text"
            placeholder="Filtrar"
            v-model="filtersId[0].value"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br>

    <b-row>
      <b-col lg="12">             
        <div ref="refTable3">
          <data-tables ref="refTable3"
            :data="data2"
            name="table2"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filtersId"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titles2"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
                <template slot-scope="scope">
                    <div v-if="title.prop == 'codigo'">  
                        <b-link type="text" v-if="scope.row.codigo > 0" @click="selecciona_afianzado(scope.row.codigo, scope.row.rut, scope.row.nombre)" >{{scope.row.codigo}}</b-link>
                        <p v-else >{{scope.row.codigo}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>
              
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>


    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConsultaCliente from "@/components/services/apiConsultaCliente";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


import XLSX from "xlsx";
import Persona from './persona.vue';
import Polizas from './polizas.vue';
import Deudas from './deudas.vue';
import Siniestros from './siniestros.vue';
import Cumulo from './cumulo.vue';
import Monedas from './monedas.vue';
import Contragarantias from './contragarantias.vue';



export default {
  name: "BaseAsegurado",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      datapoliza:[],
      modalNombre: false,
      modalId: false,
      hasCorredor: false,
      exportar: false,
      tieneAcceso: true,
      consulta: false,
      tabIndex: 0,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      
      data: [],
      data1: [],
      data2: [],

      titles2: [
        {
          prop: "codigo",
          label: "Código",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "rut",
          label: "Rut",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "nombre",
          label: "Nombre",
          align: "left",
          minwidth:'250'
        }       
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],
      
      filtersNombre: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      filtersId: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ], 

      datosFormularioModal: {
          idcontacto: "",
          corredor: "",
          contacto: "",
          mail: "",
          femodif: "",
          usumodif: "",
      },
      limpiar: false,
      modaltitle: "",
      mostrarFechas: true,
      showAlert: false,
      variant: "",
      mensaje: "",
      dismissSecs: 5,
      dismissCountDown: 0,
      
      datosFormulario: {
          nombre: "",
          rut: "",
          poliza: "",
          codigo: "",
          feinicio: "",
          fefin: "",
          participacion: "",
          cccodigo: "",
          ccnombre: "",
          ccrut: "",
          

      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      multipleSelection: [],
      
      valParticipacion: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        // rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect,
    Persona,
    Polizas,
    Deudas,
    Siniestros,
    Cumulo,
    Monedas,
    Contragarantias
    
  },
  methods:{

    consultarTab(){
      this.tabIndex = 0;
      this.$refs["tabPersona"].recuperar_persona();

    },
    
    

    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Selec. Correo";
          obj.id = 1;
          obj.name="Selec. Correo";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.recuperar_DatCorrPol(row);
          }
          botones.push(obj);
          
          return botones;

    },

    selecciona_afianzado(p_codigo, p_rut, p_nombre){
      this.datosFormulario.cccodigo = p_codigo;
      this.datosFormulario.ccrut = p_rut;
      this.datosFormulario.ccnombre = p_nombre
      this.modalNombre = false;
      this.modalId = false;
      this.tieneAcceso=false; 
      this.consulta=true;
      
    }, 
    
    
    

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },

    valmarcados(p_opcion){
  
      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */

       this.multipleSelection = marcados;
      if (this.multipleSelection.length > 0){
         if (p_opcion == 'D') {this.modalDesactivar = true}
      }else{
        this.crearNotificacion(
                "Marcar",
                "No tiene registros seleccionados.",
                "error"
              );
      }
      
    },

    pre_insertar_limpiar(){
      this.limpiar = true;
      this.pre_insertar();

    },

    Limpiar() {
      
      this.datosFormulario.codigo = "";
      this.datosFormulario.rut = "";
      this.datosFormulario.nombre = "";
      this.datosFormulario.poliza = "";
    },

    
    pre_insertar() {
      this.$Progress.start(); 
      this.exportar = false;
      
      
      this.datosFormulario.feinicio = "";
      this.datosFormulario.fefin = "";
      this.datosFormulario.participacion = 1;
      

      return apiConsultaCliente
        .pre_insertar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          
          response.data = this.keysMinuscula(response.data);


          
          var InfoFechas = response.data.fechas;
          for (var i = 0; i < InfoFechas.length; i++) {
              this.datosFormulario.feinicio = InfoFechas[i]["fe_inicio"];
              this.datosFormulario.fefin = InfoFechas[i]["fe_fin"];
            }

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's' && this.limpiar == false) {
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          //  carga de listados
          this.valParticipacion = this.llenaArrayLista(response.data.participa, 'codigo', 'descripcion', false);
          
          

          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    formatter(row, column) {
      if ((column.property == "fecha"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },
    
    

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    buscar_por_nombre: function(){
      
      this.$Progress.start();
      var p_nombre = this.datosFormulario.nombre == '' ? '': this.datosFormulario.nombre;
      var p_email = this.$session.get("mail");
      var p_usuario = this.$session.get("usuarioInterno");
       
       if ((p_nombre == '')){
           this.datosFormulario.nombre ="";
           this.mensaje= "Ingrese un nombre.";
           this.variant="warning";
           this.showAlert = true;
           this.$Progress.finish();
           return false;
            
       }
     
      return apiConsultaCliente
        .buscar_nombre(
          p_email, p_usuario, p_nombre
        ).then((response) => {
         response.data = this.keysMinuscula(response.data);
          this.data1 = response.data.res;
          this.modalNombre = true;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert = true;
          this.$Progress.finish();
        });

    },

    buscar_por_rut: function(){
      
      this.$Progress.start();
      var p_poliza = this.datosFormulario.poliza == '';
      var p_rut = this.datosFormulario.rut == '' ? '': this.datosFormulario.rut;
      var p_codigo = this.datosFormulario.codigo == '';

      var p_email = this.$session.get("mail");
      var p_usuario = this.$session.get("usuarioInterno");
       
        if ((p_rut == '')){
           this.datosFormulario.rut ="";
           this.mensaje= "Ingrese un Rut.";
           this.variant="warning";
           this.showAlert = true;
           this.$Progress.finish();
           return false;
        }
        
     
      return apiConsultaCliente
        .buscar_por_id(
          p_email, p_usuario, p_poliza, p_rut, p_codigo
        ).then((response) => {
         response.data = this.keysMinuscula(response.data);
          this.data2 = response.data.res;
          this.modaltitle = " Busqueda por Rut",
          this.modalId = true;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert = true;
          this.$Progress.finish();
        });

    },

    buscar_por_poliza: function(){
      
      this.$Progress.start();
      var p_poliza = this.datosFormulario.poliza == '' ? '': this.datosFormulario.poliza;
      var p_rut = this.datosFormulario.rut == '';
      var p_codigo = this.datosFormulario.codigo == '';

      var p_email = this.$session.get("mail");
      var p_usuario = this.$session.get("usuarioInterno");
       
        if ((p_poliza == '')){
           this.datosFormulario.p_poliza ="";
           this.mensaje= "Ingrese el número de póliza";
           this.variant="warning";
           this.showAlert = true;
           this.$Progress.finish();
           return false;
        }
        
     
      return apiConsultaCliente
        .buscar_por_id(
          p_email, p_usuario, p_poliza, p_rut, p_codigo
        ).then((response) => {
         response.data = this.keysMinuscula(response.data);
          this.data2 = response.data.res;
          this.modaltitle = " Busqueda por Póliza",
          this.modalId = true;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert = true;
          this.$Progress.finish();
        });

    },

    buscar_por_codigo: function(){
      
      this.$Progress.start();
      var p_poliza = this.datosFormulario.poliza == '';
      var p_rut = null; //this.datosFormulario.rut == '';
      var p_codigo = this.datosFormulario.codigo == '' ? '': this.datosFormulario.codigo;

      var p_email = this.$session.get("mail");
      var p_usuario = this.$session.get("usuarioInterno");
       
        if ((p_codigo == '')){
           this.datosFormulario.codigo = "";
           this.mensaje= "Ingrese el Código";
           this.variant="warning";
           this.showAlert = true;
           this.$Progress.finish();
           return false;
        }
        
     
      return apiConsultaCliente
        .buscar_por_id(
          p_email, p_usuario, p_poliza, p_rut, p_codigo
        ).then((response) => {
         response.data = this.keysMinuscula(response.data);
          this.data2 = response.data.res;
          this.modaltitle = " Busqueda por Código",
          this.modalId = true;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert = true;
          this.$Progress.finish();
        });

    },

    intersection(o1, o2) {
    return Object.keys(o1).concat(Object.keys(o2)).sort().reduce(function (r, a, i, aa) {
        if (i && aa[i - 1] === a) {
            r.push(o1[a].value);
        }
         return r;
    }, []);
    },

  

    
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();  
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
    data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
            // this.toggleSelection([lista[index]]);
        }
      })
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
